import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

import { rem } from '../themeUtils';

const paginationSlotRecipe = defineSlotRecipe({
  className: 'pagination',
  slots: ['itemsBlock', 'itemsSelect', 'pageBlock', 'pageSelect', 'root', 'text'],
  base: {
    itemsBlock: {
      display: 'flex',
      alignItems: 'center',
      gap: '8',
      flexShrink: 0,
    },
    itemsSelect: {
      width: rem(88),
    },
    pageBlock: {
      display: 'flex',
      alignItems: 'center',
      gap: '8',
      flexShrink: 0,
    },
    pageSelect: {
      width: rem(80),
    },
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      overflow: 'clip',
      width: 'full',
    },
    text: {
      textStyle: 'body/md/regular',
      whiteSpace: 'nowrap',
      flexShrink: 0,
    },
  },
  variants: {
    variant: {
      card: {
        root: {
          paddingInline: '24',
          paddingBlock: '8',
        },
        text: {
          color: 'text/tertiary',
        },
      },
      page: {
        root: {
          paddingInline: '24',
          paddingBlock: '16',
          borderTopWidth: '1',
          borderTopStyle: 'solid',
          borderTopColor: 'border/regular',
        },
        text: {
          color: 'text/secondary',
        },
      },
      table: {
        root: {
          paddingInline: '16',
          paddingBlock: '8',
        },
        text: {
          color: 'text/secondary',
        },
      },
    },
  },
  defaultVariants: {
    variant: 'table',
  },
});

export default paginationSlotRecipe;
